import { render, staticRenderFns } from "./bxDeptConf.vue?vue&type=template&id=6b3e1c6a&scoped=true&"
import script from "./bxDeptConf.vue?vue&type=script&lang=js&"
export * from "./bxDeptConf.vue?vue&type=script&lang=js&"
import style0 from "./bxDeptConf.vue?vue&type=style&index=0&id=6b3e1c6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3e1c6a",
  null
  
)

export default component.exports